<template>
  <div class="protected page">
    <AppHeader back_button config_button>{{$root.texts.section_list.title}}</AppHeader>
    <FloorMenu></FloorMenu>
    <div class="protected__content" id="audioList">
      <ListAudios ref="list_audios"></ListAudios>
      <footer>
        <input
          id="num_audio"
          class="text-input small-text-input"
          type="tel"
          autocomplete="off"
          autocorrect="off"
          v-model.number="code"
          v-on:keyup="keymonitor"
          :placeholder="$root.texts.section_list.input_code_hint"
        >
        <div
          :class="{btn:true, 'btn-side':true, 'btn-disabled':isButtonDisabled}"
          @click="openAudio"
        >
          <img class="header-icon-small" src="../assets/_ionicons_svg_ios-arrow-back.svg">
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import AppHeader from "@/components/AppHeader.vue";
import FloorMenu from "@/components/FloorMenu.vue";
import ListAudios from "@/components/ListAudios.vue";

export default {
  name: "protected",
  data() {
    return {
      code: null,
      isButtonDisabled: true,
      showErrorMessage: false
    };
  },
  watch: {
    code: function(val) {
      if (val == null || val == "" || val.length == 0) {
        this.isButtonDisabled = true;
        this.showErrorMessage = false;
      } else {
        this.isButtonDisabled = false;
      }
    }
  },
  methods: {
    keymonitor: function(e) {
      if (e.key == "Enter") this.openAudio();
    },
    openAudio: function() {
      let audioSelected = this.$root.audio_selected;
      let num = parseInt(this.code);
      let numFloor = Math.floor(num / 100); // Floors starts at 0...
      let numAudio = (num % 100) - 1; // Arrays start at 0, but audio numbers at 1...
      // Check audio and floor
      if (
        !(
          numFloor == this.$root.floor_selected &&
          numAudio == this.$root.audio_selected
        )
      ) {
        if (
          numFloor >= 0 &&
          numFloor < this.$root.audios[0].json.length &&
          numAudio >= 0 &&
          numAudio < this.$root.audios[0].json[numFloor].media.length
        ) {
          this.$root.floor_selected = numFloor;
          let __this = this;
          if (audioSelected == numAudio) {
            this.$root.audio_selected = -1;
            setTimeout(function() {
              __this.$root.audio_selected = numAudio;
            }, 100);
          } else {
            this.$root.audio_selected = numAudio;
          }
          setTimeout(function() {
            __this.$refs.list_audios.scrollToElement();
          }, 250);
          this.code = "";
          document.activeElement.blur();
        }
      }
    }
  },
  components: {
    AppHeader,
    FloorMenu,
    ListAudios
  }
};
</script>